import React from 'react';
import { PlusCircle, Question } from '@phosphor-icons/react';
import classNames from 'classnames';

import { trackCreateProject } from '../../../analytics';

import { URL } from '../../../constants';

import useAuthUserStore from '../../../hooks/useAuthUserStore';

import { getHelpUrl, toggleAdminMode } from '../../../utils';

import { Logo } from '../../general';
import { useSequence } from './components/useSequence';
import {
  MainSideNav,
  ProjectSideNav,
  SideNavMainBtn,
  ProfileDropdown,
  SideNavType,
} from '.';

interface Props {
  type: SideNavType;
  show: boolean;
}

const SideNav: React.FC<Props> = (props) => {
  const { type, show } = props;

  const { user, adminMode, setAdminMode } = useAuthUserStore();

  const pathname = window.location.pathname;

  useSequence({
    handleAction: () => toggleAdminMode(user, adminMode, setAdminMode),
  });

  return (
    <aside
      id="side-nav"
      className={classNames({
        'sticky top-[var(--header-height)] lg:top-0 w-[var(--side-nav-width)] h-[calc(100dvh_-_var(--header-height))] lg:h-screen flex flex-col items-center p-[var(--page-spacing)] gap-8 z-40 bg-grey-100 transition-all': true,
        'translate-x-0 opacity-100': show,
        '-translate-x-full opacity-0': !show,
      })}
      aria-label="SideNav"
    >
      <div className="shrink-0 flex flex-col items-center gap-8">
        <Logo variant="square" width="32px" className="hidden lg:block" />

        <SideNavMainBtn
          id="create"
          Icon={PlusCircle}
          url={URL.PROJECT_SETTINGS}
          onClick={() => trackCreateProject('Side Nav')}
          label="Create"
          isFull
        />
      </div>

      <div className="flex flex-1 flex-col gap-8 overflow-y-auto overscroll-contain">
        {type === 'main' && <MainSideNav />}
        {type === 'project' && <ProjectSideNav />}
      </div>

      <div className="shrink-0 flex flex-col gap-4">
        <SideNavMainBtn
          id="help"
          Icon={Question}
          url={getHelpUrl()}
          label="Help"
          isCurrent={pathname.includes(getHelpUrl())}
        />

        <ProfileDropdown />
      </div>
    </aside>
  );
};

export default SideNav;
